import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { placeholder, wellness } from "../utils"; // Replace with your actual image import

gsap.registerPlugin(ScrollTrigger);

const Highlights3 = () => {
  useEffect(() => {
    // Optional: Add GSAP animations or ScrollTrigger logic here
  }, []);

  return (
    <section className="bg-white text-gray-900 lg:py-20 py-16 px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left Section */}
        <div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Unsere Geschichte
          </h2>
          <p className="text-lg md:text-xl mb-8 leading-relaxed">
            Nutzen Sie diesen Bereich, um sich oder Ihr Unternehmen den
            Besuchern der Website vorzustellen. Teilen Sie mit, wer Sie sind,
            was Sie tun und was der Zweck dieser Website ist.
          </p>

          {/* Stats */}
          <div className="flex flex-row gap-8 mt-8">
            {/* Stat 1 */}
            <div>
              <span className="block text-4xl md:text-5xl font-extrabold text-gray-800">
                1000+
              </span>
              <span className="text-lg md:text-xl text-gray-600">
                Zufriedene Kunden
              </span>
            </div>
            {/* Stat 2 */}
            <div>
              <span className="block text-4xl md:text-5xl font-extrabold text-gray-800">
                10+
              </span>
              <span className="text-lg md:text-xl text-gray-600">
                Jahre Erfahrung im Gebiet
              </span>
            </div>
          </div>
        </div>

        {/* Right Section (Image) */}
        <div>
          <img
            src={wellness}
            alt="Unsere Geschichte"
            className="w-full h-auto object-cover border-black border-2 rounded-md shadow-lg"
        
          />
        </div>
      </div>
    </section>
  );
};

export default Highlights3;
